import React from 'react';

const PrivacyPolicyRO: React.FC = () => {
  return (
    <div className="prose max-w-none">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Introducere</h2>
        <p className="mb-4">
          BIXMO SRL ("noi," "nostru," sau "nouă") operează aplicația mobilă și site-ul web GatherPlay ("Serviciul"). 
          Această Politică de Confidențialitate explică cum colectăm, folosim și protejăm informațiile când folosiți Serviciul nostru.
        </p>
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <p><strong>Informații de contact:</strong></p>
          <ul className="list-none mt-2 space-y-1">
            <li>Companie: BIXMO SRL</li>
            <li>Adresă: Chișinău, Moldova</li>
            <li>Email: gatherplay.application@gmail.com</li>
          </ul>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Informațiile pe care le colectăm</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">2.1 Informații pe care NU le colectăm</h3>
        <p className="mb-4">
          GatherPlay este proiectat cu confidențialitatea în minte. Nu solicităm înregistrarea utilizatorului și nu colectăm informații personale precum:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Nume, adrese de email sau numere de telefon</li>
          <li>Informații demografice</li>
          <li>Date de localizare dincolo de analize de bază la nivel de țară</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">2.2 Informații pe care le colectăm</h3>
        <p className="mb-3"><strong>Informații colectate automat:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>Informații despre dispozitiv:</strong> Tipul de dispozitiv, versiunea sistemului de operare, versiunea aplicației</li>
          <li><strong>Analitică de utilizare:</strong> Cum interacționezi cu aplicația, funcțiile folosite, durata sesiunii (colectată prin Amplitude)</li>
          <li><strong>Date tehnice:</strong> Rapoarte de erori și metrici de performanță pentru îmbunătățirea stabilității aplicației</li>
        </ul>

        <p className="mb-3"><strong>Stocare locală pe dispozitiv:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>ID jucător:</strong> Un identificator generat aleatoriu stocat local pe dispozitivul tău pentru a asigura că scenariile jocului nu se repetă pentru același jucător</li>
          <li><strong>Preferințe de joc:</strong> Setările și preferințele pe care le configurezi în aplicație</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Cum folosim informațiile</h2>
        <p className="mb-4">Folosim informațiile colectate pentru:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Îmbunătățirea performanței aplicației și corectarea erorilor</li>
          <li>Înțelegerea modului în care utilizatorii interactionează cu GatherPlay pentru a îmbunătăți experiența de joc</li>
          <li>Asigurarea că scenariile jocului nu se repetă pentru jucătorii individuali</li>
          <li>Afișarea publicității relevante (în versiunea gratuită)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Partajarea și divulgarea informațiilor</h2>
        <p className="mb-3"><strong>Servicii terțe:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>Amplitude:</strong> Folosim Amplitude pentru analiză pentru a înțelege utilizarea aplicației și a îmbunătăți experiența utilizatorului</li>
          <li><strong>Google Ads:</strong> Afișăm publicitate prin rețeaua publicitară Google în versiunea gratuită a aplicației</li>
          <li><strong>Magazine de aplicații:</strong> Statisticile de utilizare de bază pot fi partajate cu Apple App Store și Google Play Store ca parte din analiza lor standard</li>
        </ul>
        <p>Nu vindem, schimbăm sau transferăm informațiile tale către terți dincolo de acești furnizori de servicii.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Publicitate</h2>
        <p>
          Versiunea gratuită a GatherPlay afișează publicitate furnizată de Google Ads. Aceste reclame pot fi bazate pe date demografice 
          generale și interese, dar nu folosesc informații personale colectate din aplicația noastră. Poți upgrade la versiunea premium 
          pentru a elimina toate reclamele printr-o achiziție în aplicație.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Securitatea datelor</h2>
        <p>
          Implementăm măsuri tehnice și organizaționale adecvate pentru a proteja informațiile împotriva accesului neautorizat, 
          alterării, divulgării sau distrugerii. Deoarece colectăm date minime, riscul tău de confidențialitate este redus semnificativ.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Confidențialitatea copiilor</h2>
        <p>
          GatherPlay este potrivit pentru utilizatori de 6 ani și peste. Nu colectăm în mod conștient informații personale de la copii. 
          Dacă ești părinte sau tutore și crezi că copilul tău ne-a furnizat informații personale, te rugăm să ne contactezi la 
          gatherplay.application@gmail.com.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Reținerea datelor</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Date analitice:</strong> Reținute până la 2 ani pentru a analiza tendințele și a îmbunătăți serviciul</li>
          <li><strong>Date locale de pe dispozitiv:</strong> Stocate local pe dispozitivul tău și pot fi eliminate prin dezinstalarea aplicației</li>
          <li><strong>Date tehnice:</strong> Rapoartele de erori și datele de performanță reținute până la 1 an</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Drepturile tale</h2>
        <p className="mb-4">Ai dreptul să:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Soliciți informații despre ce date am colectat (limitat așa cum este descris mai sus)</li>
          <li>Soliciți ștergerea datelor tale contactându-ne</li>
          <li>Să te retragi din analiză dezactivând-o în setările dispozitivului tău</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Transferuri internaționale de date</h2>
        <p>
          Furnizorul nostru de analiză (Amplitude) poate procesa date în țări altele decât Moldova. Asigurăm că sunt implementate 
          garanții adecvate pentru orice transferuri internaționale de date.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Modificări la această Politică de Confidențialitate</h2>
        <p>
          Putem actualiza această Politică de Confidențialitate din când în când. Te vom notifica despre orice modificări postând noua 
          Politică de Confidențialitate în aplicație și actualizând data "Ultima actualizare". Utilizarea continuă a Serviciului după 
          modificări constituie acceptarea politicii actualizate.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Contactează-ne</h2>
        <p className="mb-4">Dacă ai întrebări despre această Politică de Confidențialitate, te rugăm să ne contactezi:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Email: gatherplay.application@gmail.com</li>
          <li>Companie: BIXMO SRL, Chișinău, Moldova</li>
        </ul>
      </section>

      <div className="bg-blue-50 p-4 rounded-lg mt-8">
        <p className="text-sm text-blue-800">
          Această Politică de Confidențialitate este concepută pentru a fi transparentă despre practicile noastre minime de colectare a datelor în timp ce 
          asigură conformitatea cu legile aplicabile de confidențialitate, inclusiv GDPR, CCPA și cerințele magazinelor de aplicații mobile.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyRO;